// Generated using typescript-generator version 1.10.220 on 2018-10-24 10:01:25.
// This is no longer generated - we can manually edit if needed

export interface UserTimeoutDTO extends Serializable {
    id?: number;
    userId?: number;
    period?: TimeoutPeriodType;
    startDate?: Date;
    endDate?: Date;
    removedDate?: Date;
    requestedBy?: string;
    removed?: boolean;
    removedBy?: string;
    timeoutType?: TimeoutType;
}

export interface HistoricHand extends Serializable {
    id?: string;
    table?: Table;
    startTime?: number;
    endTime?: number;
    deckInfo?: DeckInfo;
    results?: Results;
    events?: HandHistoryEvent[];
    seats?: Player[];
    settings?: Settings;
    historicTournamentId?: string;
}

export interface HistoricHandDetailResponse extends Serializable {
    hand: HistoricHand;
    prevHandId?: string;
    nextHandId?: string;
}

export interface PlayerAchievementList extends Serializable {
    achievements?: PlayerAchievementView[];
}

export interface PlayerProfile {
    userid?: number;
    username?: string;
    email?: string;
    externalUsername?: string;
    screenname?: string;
    externalAvatarUrl?: string;
    avatarId?: string;
    level?: number;
    attributes?: { [index: string]: string };
    externalUserId?: string;
    levels?: { [index: string]: number };
    broadcaster?: boolean;
}

export interface PlayerAvatar {
    userId?: number;
    userid?: number;
    avatarId?: string;
    avatarUrl?: string;
}

export interface PlayerScreenName {
    userId?: number;
    screenName?: string;
}

export interface ProductList extends Serializable {
    products?: ProductDTO[];
}

export interface BuyProductResponse extends Serializable {
    status?: BuyStatus;
}

export interface BonusStatus {
    accounts?: AccountDetails[];
    bonuses?: Bonus[];
}

export interface BalanceUpdate {
    results?: { sweeps_balance: number, gold_balance: number};
}

export interface AccountDetails {
    balance?: number;
    currency?: string;
    fractionalDigits?: number;
    role?: string;
}

export interface PlayerItemList extends Serializable {
    items?: PlayerItemView[];
}

export interface HandHistoryList {
    lastHandStartTime?: number;
    latestHandStartTime?: number;
    oldestHandStartTime?: number;
    hands?: HistoricHand[];
}

export interface UserTransactionQueryResult extends Serializable {
    transactions?: UserTransaction[];
    queryOffset?: number;
    queryLimit?: number;
    order?: TransactionsOrder;
    ascending?: boolean;
}

export interface ShareResponse {
    sharedHistoricHandId?: string;
}

export interface PlayerNote {
    playerId?: number;
    text?: string;
    category?: number;
}

export interface PlayerNoteList {
    notes?: PlayerNote[];
}

export interface Serializable {
}

export interface Table extends Serializable {
    tableId?: number;
    tableIntegrationId?: string;
    tableName?: string;
    seats?: number;
    handIndex?: number;
    tableType?: string;
}

export interface DeckInfo extends Serializable {
    size?: number;
    lowRank?: Rank;
}

export interface PotShare extends Serializable {
    potId?: number;
    amount?: number;
    playerId?: number;
    type?: string;
}

export interface BonusPotEvent extends HandHistoryEvent {
    bonusAmount: number;
}

export interface Results extends Serializable {
    totalRake?: number;
    results?: { [index: string]: HandResult };
    transfers?: PotTransfer[];
    potShares?: PotShare[];
}

export interface HandHistoryEvent extends Serializable {
    type?: string;
    time?: number;
}

export interface Player extends Serializable {
    playerId?: number;
    initialBalance?: number;
    seatId?: number;
    name?: string;
}

export interface Settings extends Serializable {
    variant?: string;
    currencyCode?: string;
    buyInCurrencyCode?: string;
    betStrategyType?: string;
    capacity?: number;
    bigBlind?: number;
    smallBlind?: number;
    ante?: number;
    broadcast?: boolean;
    winPercentage?: boolean;
    rabbitHunting?: boolean;
    attributes?: { [index: string]: string };
    remoteEventQueue?: string;
}

export interface PlayerAchievementView extends Serializable {
    achievementNameId?: string;
    name?: string;
    description?: string;
    playerId?: string;
    achieved?: boolean;
    achievedTimestamp?: string;
    imageUrl?: string;
    targetCount?: number;
    currentCount?: number;
    rank?: number;
    value?: number;
    rewardDescription?: string;
    order?: number;
    category?: string;
    minLevel?: number;
}

export interface ProductDTO extends Serializable {
    productId?: string;
    price?: number;
    currencyCode?: string;
    name?: string;
    description?: string;
    image?: string;
    itemCategory?: ItemCategory;
    category?: string;
}

export interface Bonus {
    bonusName?: string;
    canCollect?: boolean;
    timeToNextCollect?: number;
    coolDown?: number;
    bonusBalanceLowerLimit?: string;
    currencyCode?: string;
}

export interface PlayerItemView extends Serializable {
    id?: string;
    nameId?: string;
    player?: string;
    expires?: number;
    name?: string;
    description?: string;
    imageUrl?: string;
    category?: string;
    value?: number;
    equipped?: boolean;
    isEquippable?: boolean;
    voucher?: boolean;
    voucherCurrencyCode?: string;
    voucherValue?: number;
    used?: boolean;
    extras?: { [index: string]: any };
		coinType?: string;
}

export interface BonusInstanceResponse extends Serializable {
    summary?: BonusConfigSummary;
    instanceId?: string;
    playerId?: string;
    game?: string;
    nameId?: string;
    currencyCode?: string;
    counter?: number;
    released?: number;
    target?: number;
    creationDate?: Date;
    fulfilled?: boolean;
    active?: boolean;
}

export interface UserTransaction extends Serializable {
    timestamp?: Date;
    type?: string;
    provider?: string;
    amount?: Money;
}

export interface HandResult extends Serializable {
    playerId?: number;
    netWin?: number;
    totalWin?: number;
    rake?: number;
    totalBet?: number;
    transactionIds?: string[];
    timeBank?: number;
}

export interface PotTransfer extends Serializable {
    playerId?: number;
    pot?: Pot;
    amount?: number;
    fromChipStackToPlayer?: boolean;
}

export interface ProfileItem {
    name?: string;
    description?: string;
    imageUrl?: string;
    category?: string;
    value?: number;
}

export interface Money extends Serializable {
    currencyCode?: string;
    fractionalDigits?: number;
    amount?: number;
}

export interface BonusConfigSummary extends Serializable {
    release?: BonusReleaseDTO;
    name?: string;
    description?: string;
    nameId?: string;
}

export interface Pot extends Serializable {
    potId?: number;
    type?: string;
    potSize?: number;
}

export interface BonusReleaseDTO extends Serializable {
    amount?: number;
    every?: number;
}

export type BuyStatus = "OK" | "NOT_ENOUGH_FUNDS" | "WALLET_ERROR" | "ITEM_ALREADY_EXIST";

export type TransactionsOrder = "ID";

export type Rank = "TWO" | "THREE" | "FOUR" | "FIVE" | "SIX" | "SEVEN" | "EIGHT" | "NINE" | "TEN" | "JACK" | "QUEEN" | "KING" | "ACE" | "JOKER";

export type ItemCategory = "PLATE" | "AWARD" | "AVATAR" | "INVENTORY" | "TICKET";

export enum TimeoutType {
    POKER = 'POKER',
    CASINO = 'CASINO',
    PURCHASE = 'PURCHASE',
    SELF_EXCLUSION = 'SELF_EXCLUSION',
}

export enum TimeoutPeriodType {
    DAY_1 = 'DAY_1',
    DAY_3 = 'DAY_3',
    DAY_7 = 'DAY_7',
    DAY_14 = 'DAY_14',
    DAY_30 = 'DAY_30',
    DAY_90 = 'DAY_90',
    DAY_180 = 'DAY_180',
    MONTH_6 = 'MONTH_6',
    YEAR_1 = 'YEAR_1',
    YEAR_3 = 'YEAR_3',
    YEAR_5 = 'YEAR_5',
    INDEFINITE = 'INDEFINITE',
    CUSTOM = 'CUSTOM',
}
